<template>
  <!-- template for the modal component -->
  <span class="svg-icon">
    <svg
      v-if="icon === 'parking'"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M266 76H126v360h80V316h60a120.003 120.003 0 00120-120A120.003 120.003 0 00266 76zm4 160h-64v-80h64a39.996 39.996 0 0128.284 11.716 39.996 39.996 0 010 56.568A39.996 39.996 0 01270 236z"
        fill="currentcolor"
      />
    </svg>

    <svg
      v-if="icon === 'lounge'"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#prefix__clip0_871_1396)">
        <path
          d="M416 76H96v200a80.005 80.005 0 0023.431 56.569A80.005 80.005 0 00176 356h120a80.005 80.005 0 0056.569-23.431A80.005 80.005 0 00376 276v-60h40a39.86 39.86 0 0040-40v-60a39.863 39.863 0 00-40-40zm0 100h-40v-60h40v60zM56 436h360v-40H56v40z"
          fill="currentcolor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_871_1396">
          <path
            fill="currentcolor"
            transform="translate(56 76)"
            d="M0 0h400v360H0z"
          />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-if="icon === 'fasttrack'"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M332.429 76H179.571C162.755 76 149 94.518 149 117.155v288.072h214V117.155C363 94.518 349.245 76 332.429 76zm0 329.227H179.571V117.155h152.858v288.072z"
        fill="currentcolor"
      />
      <path
        d="M228.052 436V328h-21.56v-79.2a28.914 28.914 0 018.445-20.339A28.802 28.802 0 01235.238 220h43.119a28.804 28.804 0 0120.302 8.461 28.909 28.909 0 018.444 20.339V328h-21.559v108h-57.492zm28.746-230.4a28.704 28.704 0 0015.97-4.854 28.787 28.787 0 0010.588-12.925 28.849 28.849 0 00-6.232-31.386 28.74 28.74 0 00-14.718-7.882 28.698 28.698 0 00-16.609 1.639 28.755 28.755 0 00-12.901 10.608 28.842 28.842 0 00-4.844 16 28.73 28.73 0 008.39 20.394 28.62 28.62 0 0020.356 8.406z"
        fill="currentcolor"
      />
      <path
        d="M256.798 104.8c3.969 0 7.186-3.224 7.186-7.2s-3.217-7.2-7.186-7.2-7.187 3.224-7.187 7.2 3.218 7.2 7.187 7.2z"
        fill="currentcolor"
      />
    </svg>

    <svg
      v-if="icon === 'more'"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M305.953 214.072H445v100.097H305.953V449h-99.906V314.169H67V214.072h139.047V77h99.906v137.072z"
        fill="currentcolor"
      />
    </svg>

    <svg
      v-if="icon === 'packages'"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M335.994 176.722h-40.001v59.834H235.99v39.888h60.003v59.834h40.001v-59.834h60.002v-39.888h-60.002v-59.834zM55.984 256.5a139.122 139.122 0 0121.757-74.631 139.678 139.678 0 0158.446-51.418v-43.08c-35.132 12.307-65.565 35.189-87.094 65.485A178.914 178.914 0 0016 256.5a178.916 178.916 0 0033.093 103.644c21.529 30.296 51.962 53.178 87.094 65.485v-43.08a139.685 139.685 0 01-58.446-51.418A139.122 139.122 0 0155.984 256.5zM315.993 77a180.369 180.369 0 00-100.006 30.251 179.61 179.61 0 00-66.298 80.557 179.032 179.032 0 00-10.243 103.711 179.345 179.345 0 0049.263 91.907 180.171 180.171 0 0092.167 49.125 180.478 180.478 0 00104.003-10.215c32.892-13.586 61.005-36.593 80.784-66.111A179.137 179.137 0 00496 256.5c-.074-47.584-19.063-93.197-52.805-126.844C409.454 96.009 363.711 77.074 315.993 77zm0 319.111c-27.69 0-54.759-8.188-77.782-23.529a139.697 139.697 0 01-51.566-62.655 139.254 139.254 0 01-7.967-80.664 139.497 139.497 0 0138.317-71.483 140.126 140.126 0 0171.685-38.209 140.378 140.378 0 0180.891 7.945 139.918 139.918 0 0162.832 51.42 139.332 139.332 0 0123.596 77.564c-.043 37.014-14.807 72.5-41.054 98.673-26.247 26.173-61.833 40.896-98.952 40.938z"
        fill="currentcolor"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "SVGIcons",
  props: {
    icon: undefined,
  },
};
</script>

<style scoped lang="scss">
  .svg-icon {
    width: auto;
    height: auto;
    display: inline;
    svg {
      pointer-events: none;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
</style>